<template>
    <div class="sign-form">
        <Form ref="form" class="form" :model="form" :rules="ruleInline">
            <FormItem prop="phone">
                <Input type="text" ref="phoneInput" @input="removeSpaces('phone')" size="large" v-model="form.phone"
                    :placeholder="$t('login.phone')">
                <div slot="prepend" @click="goLange" class="select-qh-item">
                    <div>+{{ form.area }}</div>
                    <van-icon name="arrow-down" />
                </div>
                </Input>
            </FormItem>
            <FormItem prop="password">
                <Input ref="passwordInput" @input="removeSpaces('password')" type="password" password size="large"
                    v-model="form.password" :placeholder="$t('login.password')" />
            </FormItem>
            <FormItem prop="isAgree" class="FormItemIsAgree">
                <Checkbox v-model="form.isAgree"><span class="isAgreeTxt">{{ $t('login.remember') }}</span></Checkbox>
                <!-- <span>{{ $t('login.forget') }}</span> -->
            </FormItem>
            <FormItem class="signBtn">
                <van-button class="signbtn-con" :loading="loading" :loading-text="$t('loading.loadingLogin')"
                    @click.prevent="handleSubmit('form')" type="danger">{{ $t('login.loginBtn') }}</van-button>
            </FormItem>
            <p class="goLoginmsg">{{ $t('login.noAccount') }}<span class="goLogin" @click="goSign()">
                    {{ $t('login.goRegister') }}</span></p>
        </Form>
    </div>
</template>
<script>
import { Login } from '@/api'
export default {
    props: ['value'],
    data() {
        return {
            loading: false,
            form: {
                phone: '',
                area: '1',
                password: '',
            },
            ruleInline: {
                phone: [
                    { required: true, message: this.$t('sign.rule.phone[1]'), trigger: 'blur' },
                    // { pattern: /^1[34578]\d{9}$/, message: this.$t('sign.rule.phone[2]'), trigger: 'blur' }
                ],
                password: [
                    { required: true, message: this.$t('sign.rule.password[1]'), trigger: 'blur' },
                    { min: 6, message: this.$t('sign.rule.password[2]'), trigger: 'blur' }
                ],
            },
        }
    },
    created() {
    },
    watch: {
        value: {
            handler(newVal, oldVal) {
                this.form.area = newVal
            },
            immediate: true
        }
    },
    methods: {
        removeSpaces(field) {
            if (this.form[field] == undefined) {
                return
            }

            if (field == 'phone') {
                if (/[^\d]/.test(this.form[field])) {
                    let str = this.form[field].replace(/[^\d]/g, '');
                    this.$nextTick(() => {
                        const inputElement = this.$refs[field + 'Input'];
                        inputElement.$emit('input');
                        this.form[field] = str;
                    });
                }
            } else if (this.form[field].includes(' ')) {
                let str = this.form[field].replace(/\s+/g, '');
                this.$nextTick(() => {
                    const inputElement = this.$refs[field + 'Input'];
                    inputElement.$emit('input');
                    this.form[field] = str
                });
            }
        },
        goLange() {
            this.$router.push({
                path: '/language',
            })
        },
        handleSubmit(name) {
            this.$refs[name].validate((valid) => {
                if (valid) {
                    let data = {
                        phone: this.form.area + this.form.phone,
                        password: this.form.password,
                    }
                    this.login(data)
                }
            })
        },
        login(form) {
            this.loading = true;
            Login(form).then(res => {
                if (res.code == 1) {
                    // console.log(res);
                    this.$store.commit('setToken', res.data.token);
                    this.$store.dispatch('getInfo');
                    this.$Toast.success(res.info);
                    this.$router.push(this.$route.query.redirect || '/home')
                }
                this.loading = false;
            })
        },
        goSign() {
            this.$emit('chengeIsLogin', false)
        }
    }
}
</script>
<style lang="scss" scoped>
.sign-form {
    position: relative;
    width: 100%;
    // height: 580px;
    background-color: #fff;
    margin-top: 30px;
    display: flex;
    padding: 40px 20px;
    flex-direction: column;
    align-items: flex-start;
    gap: 30px;
    flex-shrink: 0;
    border-radius: 10px;
    box-shadow: 0px 6px 10px 0px rgba(255, 153, 0, 0.20);
    color: #000;

    .select-qh {
        width: 80px;
    }

    ::v-deep(.ivu-input) {
        padding: 0 20px;
        height: 46px;
    }


    .form {
        width: 100%;

        .select-qh-item {
            width: 50px;
            display: flex;
            align-items: center;
            justify-content: space-between;
        }

        ::v-deep(.ivu-input-group-append) {
            border-radius: 5px;
            background: #F7F7F7;
        }

        ::v-deep(.ivu-input-group-prepend) {
            border-radius: 5px;
            background: #F7F7F7;
            border: none;
        }
        ::v-deep(.ivu-input){
            border-radius: 5px;
            background: #F7F7F7;
            border: none;
            outline: none;
            box-shadow:none;
        }


        .FormItemIsAgree {
            span {
                float: right;
                font-size: 12px;
                color: #717180;
            }

            .isAgreeTxt {
                color: #717180;
                font-size: 12px;
            }

            ::v-deep(.ivu-checkbox-inner) {
                margin-right: 5px;
            }
        }

        .signBtn {
            .signbtn-con {
                height: 46px;
                width: 100%;
                border-radius: 10px;
                background: #0866ff;
                border: none;
                box-shadow: 0px 6px 10px 0px rgba(128, 128, 128, 0.50);
            }
        }

        .goLoginmsg {
            text-align: center;
            color: #717180;
            font-size: 12px;

            .goLogin {
                color: #0866FF;
            }
        }
    }
}
</style>